// Generated by ReScript, PLEASE EDIT WITH CARE


var make = (function (seed) {
  let a = (seed >>> 0) || 0x9e3779b9;
  return {
    next: function () {
      a = (a + 0x6D2B79F5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
});

var hashString = (function (s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
});

function fromSeedString(seed) {
  return make(hashString(seed));
}

function nextFloat(t) {
  return t.next();
}

export {
  make ,
  hashString ,
  fromSeedString ,
  nextFloat ,
}
/* No side effect */
